<template>
  <div>
    <!--    <page-header></page-header>-->
    <!-- 인사교육 만족도 조사 -->
    <div class="overflow-y-auto" style="height: 580px">
      <v-row class="title-wrap d-flex flex-column">
        <v-col class="bg-title">인사교육 만족도 조사</v-col>
        <v-col class="bg-title-text"
          >만족도조사란? 교육내용에 관련해 만족도를 조사합니다.</v-col
        >
      </v-row>

      <div class="px-6">
        <!--step-- value값: step진행-->
        <v-stepper value="4" elevation="0">
          <v-stepper-header class="stepper-style elevation-0">
            <v-stepper-step step="1" class="pa-0 mr-3" complete>
              step01
            </v-stepper-step>
            <v-stepper-step step="2" class="pa-0 mr-3" complete>
              step02
            </v-stepper-step>
            <v-stepper-step step="3" class="pa-0 mr-3" complete>
              step03
            </v-stepper-step>
            <v-stepper-step step="4" class="pa-0"> step04 </v-stepper-step>
          </v-stepper-header>
        </v-stepper>

        <!-- 제목 -->
        <v-row class="title-wrap my-5">
          <v-col class="pa-0 text-left">
            <div class="text-h5 font-weight-bold point-green mb-1">Q4.</div>
            <v-subheader class="subheader-text">
              <v-badge color="pink" dot left>
                대표 이미지를 선택해주세요.
              </v-badge></v-subheader
            >
          </v-col>
        </v-row>
        <!--카드형 설문 박스 -->
        <div class="satis-survey-img">
          <v-row>
            <v-col cols="6">
              <v-card elevation="0">
                <v-img src="" height="125" contain class="bg-white"></v-img>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card elevation="0">
                <v-img src="" height="125" contain class="bg-white"></v-img>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-card elevation="0">
                <v-img src="" height="125" contain class="bg-white"></v-img>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card elevation="0">
                <v-img src="" height="125" contain class="bg-white"></v-img>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-card elevation="0">
                <v-img src="" height="125" contain class="bg-white"></v-img>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card elevation="0">
                <v-img src="" height="125" contain class="bg-white"></v-img>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <!--하단버튼-->
    <v-bottom-navigation
      v-model="value"
      :input-value="active"
      fixed
      scroll-threshold="500"
      height="96"
    >
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="6" class="pr-1">
          <v-btn block elevation="0" class="btn-fixed btn-white">
            <span class="black--text">이전</span>
          </v-btn>
        </v-col>
        <v-col cols="6" class="pl-1">
          <v-btn block elevation="0" class="btn-fixed btn-grey">
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
  </div>
</template>

<script>
//import PageHeader from '@/components/common/PageHeader.vue';

export default {
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },
  components: {
    //PageHeader,
  },
  data: () => ({}),
};
</script>

<style></style>
